module.exports = __webpack_public_path__ + "img/feedback_wrong_dark.b4167a13.png";